// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBTceablRjKgGW3HB2A5k9geQ_NpBWmubw",
  authDomain: "netflix-clone-ab736.firebaseapp.com",
  projectId: "netflix-clone-ab736",
  storageBucket: "netflix-clone-ab736.appspot.com",
  messagingSenderId: "1089848546459",
  appId: "1:1089848546459:web:2932e14c94376fedbda23e",
  measurementId: "G-5HZCQ7BS1M",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
